/** @module csi/image/ImageCrop **/
define([
	"dojo/_base/lang",
	"csi/def/Action",
	"csi/view/PluginFactory",
	"csi/view/ToolbarPluginButton",
	"csi/image/ImageEditorPluginMixin"
], function(lang,Action,PluginFactory,ToolbarPluginButton,ImageEditorPluginMixin) {

	return PluginFactory.declare("crop", [ToolbarPluginButton, ImageEditorPluginMixin], {
		/**
		 * Set the action for cropping images
		 */
		constructor: function() {
			this.defAction = lang.mixin(new Action(), {
				m_id: "ImageEditorCrop",
				m_onAction: "crop"
			});
			this.defAction.setMaterialIcon("crop");
			this.defAction.resolve();
		}
	});
});